var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.loading)?_c('b-table',{staticClass:"m-0 print-tables",attrs:{"fields":_vm.fields,"items":_vm.items,"borderless":"","small":""}}):_c('div',[_vm._v("Loading")])
}
var staticRenderFns = []

export { render, staticRenderFns }